var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkemptyblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54199 4.16667C3.54199 2.90101 4.56801 1.875 5.83366 1.875H14.167C15.4326 1.875 16.4587 2.90101 16.4587 4.16667V17.5C16.4587 17.7286 16.3338 17.939 16.1332 18.0486C15.9325 18.1581 15.688 18.1494 15.4957 18.0257L10.5636 14.8551C10.2205 14.6345 9.78017 14.6345 9.43704 14.8551L4.50497 18.0257C4.31265 18.1494 4.06817 18.1581 3.8675 18.0486C3.66683 17.939 3.54199 17.7286 3.54199 17.5V4.16667Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkemptyblack);
export default __webpack_public_path__ + "static/media/bookmarkemptyblack.e173671187038d90a3d31e75da87a533.svg";
export { ForwardRef as ReactComponent };